import React, { useEffect, useRef, useState } from "react";
import Container from "./container";
import { useDispatch, useSelector } from "react-redux";
import { deleteAction } from "../../../store/actions/CommonActions";
import Swal from "sweetalert2";

const PROJECT_FILTER_STORAGE_KEY = "projectListStatusFilters";

function loadProjectFiltersFromStorage(store) {
  if (store !== "projects") return [];
  try {
    const raw = sessionStorage.getItem(PROJECT_FILTER_STORAGE_KEY);
    const v = raw ? JSON.parse(raw) : [];
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
}

export const globaltriggerDelete = async ({ endPoint, dispatch, callback }) => {
  try {
    Swal.fire({
      title: "Are you sure to delete ?",
      text: "You will not be able to recover the record !!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#BE282D",
      cancelButtonColor: "#aaa",
      confirmButtonText: "Yes, delete it!",
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          const response = await deleteAction(endPoint);
          console.log('svnsioevnsev', response);
          if (response) {
            callback();
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  } catch (error) {
    console.log(error);
  }
};

const CustomTable = ({
  title,
  getHook,
  store,
  columns,
  deleteHook,
  addBtnTitle,
  secondBtnTitle,
  formModal,
  modalConfig,
  search,
  showStats = false,
  filterIcon = false,
  onRowClick = () => { },
  isEdit = true,
  isDelete = true,
  filters,
  importData,
  FilterComponent,
  startOnPageOne = false,
}) => {
  const dispatch = useDispatch();
  const tmpData = useSelector((state) => state[store]);
  const { data, page, total, totalPages, isLoading, stats } = tmpData;
  const [currentPage, setCurrentPage] = useState(() => (startOnPageOne ? 1 : page));
  const [searchTerm, setSearchTerm] = useState("");
  const [filterOption, setFilterOption] = useState(() =>
    loadProjectFiltersFromStorage(store)
  );
  const pageSize = 10;
  const isInitialSearchMount = useRef(true);
  const isInitialFilterMount = useRef(true);
  const skipFilterDebounce = useRef(false);

  useEffect(() => {
    try {
      dispatch(
        getHook({ page: currentPage, search: searchTerm, filters: filterOption, limit: pageSize })
      );
    } catch (error) {
      console.log(error);
    }
  }, [currentPage]);

  useEffect(() => {
    if (isInitialSearchMount.current) {
      isInitialSearchMount.current = false;
      return;
    }
    const delayDebounce = setTimeout(() => {
      try {
        dispatch(
          getHook({ page: currentPage, search: searchTerm, filters: filterOption, limit: pageSize })
        );
      } catch (error) {
        console.log(error);
      }
    }, 500);
    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  useEffect(() => {
    if (isInitialFilterMount.current) {
      isInitialFilterMount.current = false;
      return;
    }
    if (skipFilterDebounce.current) {
      skipFilterDebounce.current = false;
      return;
    }
    const delayDebounce = setTimeout(() => {
      try {
        dispatch(
          getHook({ page: 1, search: searchTerm, filters: filterOption, limit: pageSize })
        );
      } catch (error) {
        console.log(error);
      }
    }, 500);
    return () => clearTimeout(delayDebounce);
  }, [filterOption]);

  const refetchData = () => {
    dispatch(
      getHook({ page: currentPage, search: searchTerm, filters: filterOption, limit: pageSize })
    );
  };
  const onClick = (i) => {
    setCurrentPage(i);
  };
  const searchAudience = (s) => {
    setSearchTerm(s);
  };
  const handleFilters = (filters) => {
    setFilterOption(filters);
  };

  const handleApplyTableFilters = (nextFilters) => {
    if (store === "projects") {
      try {
        sessionStorage.setItem(
          PROJECT_FILTER_STORAGE_KEY,
          JSON.stringify(nextFilters)
        );
      } catch (_) {}
    }
    skipFilterDebounce.current = true;
    setFilterOption(nextFilters);
    setCurrentPage(1);
    dispatch(
      getHook({
        page: 1,
        search: searchTerm,
        filters: nextFilters,
        limit: pageSize,
      })
    );
  };

  const triggerDelete = async (i) => {
    const callback = () =>
      dispatch(
        getHook({
          page: currentPage,
          search: searchTerm,
          filters: filterOption,
          limit: pageSize,
        })
      );
    globaltriggerDelete({ endPoint: `${deleteHook}/${i._id}`, dispatch, callback });
  };
  return (
    <Container
      columns={columns}
      isLoading={isLoading}
      onClick={onClick}
      addBtnTitle={addBtnTitle}
      secondBtnTitle={secondBtnTitle}
      data={data}
      pageSize={pageSize}
      title={title}
      totalPages={totalPages}
      currentPage={currentPage}
      total={total}
      triggerDelete={triggerDelete}
      formModal={formModal}
      modalConfig={modalConfig}
      refetchData={refetchData}
      search={search}
      searchAudience={searchAudience}
      stats={stats}
      showStats={showStats}
      filterIcon={filterIcon}
      onRowClick={onRowClick}
      handleFilters={handleFilters}
      filterOption={filterOption}
      setFilterOption={setFilterOption}
      filters={filters}
      isEdit={isEdit}
      isDelete={isDelete}
      importData={importData}
      FilterComponent={FilterComponent}
      appliedFilters={filterOption}
      onApplyFilters={handleApplyTableFilters}
    />
  );
};

export default CustomTable;
